import "./App.css";
import { Home } from "./pages/Home";
import { EmsatReports } from "./pages/EmsatReports";
import { OlympaidReport } from "./pages/Olaympaid";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ScoreReports } from "./pages/scoreReports";
import { HotsOlympaidReport } from "./pages/HotsOlympaid";
import SchoolReports from "./pages/SchoolReports";
import NotFound from "./pages/NotFound";
import BasicReportPage from "./pages/BasicReportPage";
import { SESReports } from "./pages/SESReports";
import { ASTReports } from "./pages/ASTReports";
import { WITReports } from "./pages/WITReports";

function App() {
  return (
    <div className="body-wrapbox theme-exam">
      <section className="student__onboarding__widget w-100">
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/score-report/:crnId/:eventId"
              element={<ScoreReports />}
            />
            <Route
              path="/scienceolympiad-report/:crnId/:eventId"
              element={<ScoreReports />}
            />
            <Route
              path="/scoreoffline-report/:crnId/:eventId"
              element={<ScoreReports />}
            />
            <Route
              path="/iemsat-report/:crnId/:eventId"
              element={<EmsatReports />}
            />
            <Route
              path="/matholympiad-report/:crnId/:eventId"
              element={<OlympaidReport />}
            />
            <Route
              path="/hotsolympiad-report/:crnId/:eventId"
              element={<HotsOlympaidReport />}
            />
            <Route
              path="/geniusintelligencescaletest-report/:crnId/:eventId"
              element={<WITReports />}
            />
            <Route
              path="/geniussemifinal-report/:crnId/:eventId"
              element={<ScoreReports />}
            />
            <Route
              path="/geniusfinal-report/:crnId/:eventId"
              element={<ScoreReports />}
            />
            <Route
              path="/revisiontest-report/:crnId/:eventId"
              element={<ScoreReports />}
            />
            <Route
              path="/school-report/:schoolId/:eventId"
              element={<SchoolReports />}
            />
            <Route
              path="/yec-report/:crnId/:eventId"
              element={<BasicReportPage />}
            />
            <Route
              path="/basic-report/:crnId/:eventId"
              element={<BasicReportPage />}
            />
            <Route
              path="/scoreedgescholarshiptest-report/:crnId/:eventId"
              element={<SESReports />}
            />
            <Route
              path="/scoreedge-report/:crnId/:eventId"
              element={<SESReports />}
            />
            <Route
              path="/atreyascholarshiptest-report/:crnId/:eventId"
              element={<ASTReports />}
            />
            <Route path="*" element={<NotFound />} />{" "}
            {/* Catch-all route for 404 */}
          </Routes>
        </Router>
      </section>
    </div>
  );
}

export default App;
